import { render, staticRenderFns } from "./look-coupon.vue?vue&type=template&id=52e2206c&scoped=true&"
import script from "./look-coupon.vue?vue&type=script&lang=ts&"
export * from "./look-coupon.vue?vue&type=script&lang=ts&"
import style0 from "./look-coupon.vue?vue&type=style&index=0&id=52e2206c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e2206c",
  null
  
)

export default component.exports